var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flipper",class:_vm.ura,attrs:{"id":"flipCard"}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.cardImage),expression:"cardImage"}],class:_vm.omotecss,attrs:{"alt":""}}),_c('img',{class:_vm.uracss,attrs:{"src":_vm.uraImage,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }